import { IAddressBase } from '../../models/address';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';
import { IDetailedAppointment } from './ShowAppointmentsService';

export interface IAppointmentPayment {
  acquirerName?: string;
  acquirerNsu?: string;
  authorizationCode?: string;
  authorizedAt?: Date;
  brand?: string;
  installments?: number;
  type: 'CREDIT_CARD' | 'DEBIT_CARD' | 'PIX' | 'CASH';
}

interface ICreateAppointmentExternalPaymentsService {
  address?: IAddressBase;
  appointmentId: string;
  payment: IAppointmentPayment;
}

export type IAppointmentExternalPayment = IDetailedAppointment;

export const createAppointmentExternalPaymentsService = async ({
  appointmentId,
  payment,
}: ICreateAppointmentExternalPaymentsService): Promise<IAppointmentExternalPayment> => {
  const { data } = await jhsfBookingsApi.post<IAppointmentExternalPayment>(
    `/appointments/${appointmentId}/external-payments`,
    payment,
  );

  return data;
};
